import React, { useState } from 'react'
import Button from '../Reusable/Button'
import Signup from './Signup'

const AuthBody = () => {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [error, setError] = useState(false)

    const payload = {
        userEmail: email,
        password: password
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        if (!email && !password) {
            setError(true)
            setTimeout(()=>{
                setError(false)
            }, 2000)
        } else {
            localStorage.setItem('login', payload)
        }
    }


    return (
        <div className='flex lg:flex-row flex-col gap-8 lg:gap-10 w-full lg:py-14 py-7 relative'>
            <div className='absolute lg:block hidden w-[400px] h-[400px] left-[-200px] top-[-200px] bg-blue-400 bg-opacity-30 rounded-full blur-3xl'></div>
            <div className='lg:w-1/2 w-full border-white border-opacity-70'>
                <form class="border-[1px] p-5 w-full gap-4 rounded-lg flex flex-col">
                    {error && (
                        <p className='text-sm text-red-500'>All Fields are required</p>
                    )}
                    <p className='lg:text-[44px] text-[22px] font-semibold text-white'>LOGIN</p>
                    <div class="relative z-0 w-full mb-5 group">
                        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" name="floating_email" id="floating_email" class="block py-3 px-2 w-full text-lg text-gray-200 rounded-md p-2 border-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-white peer bg-transparent" placeholder="" required />
                        <label for="floating_email" class="peer-focus:font-medium bg-transparent absolute text-lg text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-0 left-4 z-100 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-white peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Email address</label>
                    </div>
                    <div class="relative z-0 w-full mb-5 group">
                        <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" name="floating_password" id="floating_password" class="block py-3 px-2 w-full text-lg text-gray-900 rounded-md border-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-white peer bg-transparent" placeholder=" " required />
                        <label for="floating_password" class="peer-focus:font-medium absolute text-lg text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-0 -z-10 left-4 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-white peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Password</label>
                    </div>
                    <button onClick={handleSubmit} className='started  w-full px-2 py-3 rounded-xl text-white lg:text-[18px] text-[14px] flex items-center justify-center'>Login Now</button>

                </form>
            </div>

            <Signup/>

        </div>
    )
}

export default AuthBody